let activeLocks = 0;
let previousOverflow = "";

export function lockBodyScroll(): (() => void) | undefined {
  if (typeof document === "undefined") return;
  if (activeLocks === 0) {
    previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
  }
  activeLocks += 1;
  let isReleased = false;

  return () => {
    if (isReleased) return;
    isReleased = true;
    activeLocks -= 1;
    if (activeLocks === 0) {
      document.body.style.overflow = previousOverflow;
    }
  };
}
